import { Component, Injector, ViewChild } from '@angular/core';
import { PRESCRIPTION_INFO, PRESCRIPTION_MEDICINE } from 'src/app/modules/payments/helper/helper';
import { ModalService } from 'src/app/shared/service/modal.service';
import { PatientsService } from '../../service/patients.service';
import { ResponseData, tableBuilder, tblFilterQuery } from 'src/app/helper/interface/response';
import { RESPONSE_CODE } from 'src/app/helper/class/app-constant';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AlertService } from 'src/app/helper/service/alert.service';
import { ActivatedRoute } from '@angular/router';
import { TableListComponent } from 'src/app/shared/form/component/table-list/table-list.component';

@Component({
  selector: 'app-prescription-info',
  templateUrl: './prescription-info.component.html',
  styleUrl: './prescription-info.component.scss'
})
export class PrescriptionInfoComponent {

  isModal: boolean = false;
  dataLoading: boolean = false;
  prescriptionFormData: any = PRESCRIPTION_INFO
  prescriptionData: any
  _bsModalRef: BsModalRef = {} as BsModalRef;
  prescriptionId: any
  medicineList: any[] = []
  @ViewChild('tableData') tableData: TableListComponent | undefined;

  tableConfig: tableBuilder = {
    name: 'Medicine list',
    column: PRESCRIPTION_MEDICINE,
    action: [],
  };


  constructor(private modalService: ModalService, private patientApi: PatientsService, private injector: Injector, private alertService: AlertService, private activatedRoute: ActivatedRoute,) { }

  ngOnInit(): void {
    this.prescriptionId = this.activatedRoute.snapshot.queryParams['id'] || '';
    if (this.prescriptionId) {
      this.getPrescriptionById(this.prescriptionId);
    }
  }

  setInput(data: any) {
    this.prescriptionId = data
    this._bsModalRef = this.injector.get<BsModalRef>(BsModalRef);
    this.isModal = true
    if (this.prescriptionId) {
      this.getPrescriptionById(data.id);
    }
  }



  getPrescriptionById(id: any) {
    console.log('id', id);
    this.dataLoading = true
    this.patientApi.prescriptionGetById(id).then((res: ResponseData) => {
      console.log('res', res);
      if (res.statusCode === RESPONSE_CODE.SUCCESS) {
        this.prescriptionData = res.result
        // console.log('prescription data', this.prescriptionData);
        // this.medicineList=[]
        this.medicineList = this.prescriptionData?.prescription_item
        // console.log('medicine list', this.medicineList);
      }
    }).finally(() => this.dataLoading = false)
  }

  getMedicineData = async (e: tblFilterQuery): Promise<any> => {
    return {
      statusCode: 200,
      result: this.medicineList,
    }
  };


  close() {
    this.modalService.close()
  }

}
